import React, { useEffect, useState } from 'react';
import api, { BASE_URL, fotoUrl } from '../api';
import { useAuth } from '../AuthContext';

interface DevUser {
  id: string; ad: string; soyad: string; email: string;
  foto_url: string | null; rol: 'admin' | 'super_admin' | 'sube_admin' | 'egitmen' | 'ogrenci';
}

const ROL_RENK: Record<string, [string, string]> = {
  admin:       ['#FCEBEB', '#A32D2D'],
  super_admin: ['#FCEBEB', '#A32D2D'],
  sube_admin:  ['#FEF3E2', '#B45309'],
  egitmen:     ['#EEEDFE', '#534AB7'],
  ogrenci:     ['#EAF3DE', '#3B6D11'],
};

export default function DevPanel() {
  const { kullanici } = useAuth();
  const [acik, setAcik] = useState(false);
  const [kullanicilar, setKullanicilar] = useState<DevUser[]>([]);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [arama, setArama] = useState('');

  useEffect(() => {
    if (!acik || kullanicilar.length > 0) return;
    setYukleniyor(true);
    api.get('/api/dev/kullanicilar')
      .then(r => setKullanicilar(r.data))
      .catch(() => {})
      .finally(() => setYukleniyor(false));
  }, [acik]);

  const impersonate = async (u: DevUser) => {
    try {
      const r = await api.post('/api/dev/impersonate', { id: u.id, rol: u.rol });
      localStorage.setItem('token', r.data.token);
      // role göre yönlendir
      const hedef = u.rol === 'ogrenci' ? '/profilim' : u.rol === 'egitmen' ? '/egitmen' : '/';
      window.location.href = hedef;
    } catch { alert('Impersonate başarısız'); }
  };

  const filtreli = kullanicilar.filter(u =>
    `${u.ad} ${u.soyad}`.toLowerCase().includes(arama.toLowerCase()) || u.rol.includes(arama.toLowerCase())
  );

  const gruplar: Record<string, DevUser[]> = { admin: [], egitmen: [], ogrenci: [] };
  filtreli.forEach(u => gruplar[u.rol]?.push(u));

  const [rolBg, rolRenk] = ROL_RENK[kullanici?.rol ?? 'admin'] ?? ROL_RENK['admin'];

  return (
    <div style={{ position: 'fixed', bottom: 16, right: 16, zIndex: 9999, fontFamily: 'sans-serif' }}>
      {/* Panel */}
      {acik && (
        <div style={{
          position: 'absolute', bottom: 52, right: 0,
          background: 'white', border: '1px solid #e0e0e0', borderRadius: 12,
          boxShadow: '0 8px 32px rgba(0,0,0,.15)', width: 280,
          display: 'flex', flexDirection: 'column', maxHeight: 460, overflow: 'hidden',
        }}>
          <div style={{ padding: '12px 14px 8px', borderBottom: '1px solid #f0f0f0' }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: '#888', letterSpacing: .5, marginBottom: 8 }}>DEV — KULLANICI DEĞİŞTİR</div>
            <input
              value={arama} onChange={e => setArama(e.target.value)}
              placeholder="İsim ara..."
              autoFocus
              style={{ width: '100%', padding: '6px 10px', borderRadius: 7, border: '1px solid #eee', fontSize: 12, boxSizing: 'border-box', outline: 'none' }}
            />
          </div>

          <div style={{ overflowY: 'auto', flex: 1 }}>
            {yukleniyor ? (
              <div style={{ padding: 20, textAlign: 'center', color: '#aaa', fontSize: 12 }}>Yükleniyor...</div>
            ) : (
              (['admin', 'egitmen', 'ogrenci'] as const).map(rol => {
                const grup = gruplar[rol];
                if (!grup.length) return null;
                const [bg, renk] = ROL_RENK[rol];
                return (
                  <div key={rol}>
                    <div style={{ padding: '6px 14px 4px', fontSize: 10, fontWeight: 700, color: renk, background: bg, textTransform: 'uppercase', letterSpacing: .5 }}>
                      {rol === 'admin' ? 'Admin' : rol === 'egitmen' ? 'Eğitmenler' : 'Öğrenciler'}
                    </div>
                    {grup.map(u => {
                      const aktif = kullanici?.id === u.id;
                      return (
                        <div key={u.id} onClick={() => !aktif && impersonate(u)} style={{
                          display: 'flex', alignItems: 'center', gap: 9,
                          padding: '8px 14px', cursor: aktif ? 'default' : 'pointer',
                          background: aktif ? bg : 'white',
                          borderBottom: '1px solid #f8f8f8',
                          transition: 'background .1s',
                        }}
                          onMouseEnter={e => { if (!aktif) (e.currentTarget as HTMLDivElement).style.background = '#fafafa'; }}
                          onMouseLeave={e => { if (!aktif) (e.currentTarget as HTMLDivElement).style.background = 'white'; }}
                        >
                          {u.foto_url
                            ? <img src={fotoUrl(u.foto_url)} alt="" style={{ width: 28, height: 28, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }} />
                            : <div style={{ width: 28, height: 28, borderRadius: '50%', background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, color: renk, flexShrink: 0 }}>
                                {u.ad.charAt(0)}
                              </div>
                          }
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: 12, fontWeight: aktif ? 700 : 500, color: aktif ? renk : '#333', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                              {u.ad} {u.soyad}
                            </div>
                          </div>
                          {aktif && <span style={{ fontSize: 10, color: renk, fontWeight: 700 }}>AKTİF</span>}
                        </div>
                      );
                    })}
                  </div>
                );
              })
            )}
          </div>
        </div>
      )}

      {/* Toggle butonu */}
      <button onClick={() => setAcik(p => !p)} style={{
        background: '#1a1a2e', color: 'white', border: 'none', borderRadius: 10,
        padding: '7px 12px', cursor: 'pointer', fontSize: 11, fontWeight: 600,
        display: 'flex', alignItems: 'center', gap: 7, boxShadow: '0 2px 8px rgba(0,0,0,.3)',
      }}>
        <span style={{ background: rolBg, color: rolRenk, borderRadius: 4, padding: '1px 6px', fontSize: 10, fontWeight: 700 }}>
          {kullanici?.rol?.toUpperCase()}
        </span>
        <span style={{ maxWidth: 90, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {kullanici?.ad}
        </span>
        <span style={{ opacity: .6 }}>{acik ? '▼' : '▲'}</span>
      </button>
    </div>
  );
}
